(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name season
   * @description
   *
   */
  angular
  .module('neo.home.seasons.season', [
    'ui.router'
  ]);
}());
